const breakpoints = {
    device: {
        mobile: `320px`,
        tablet: `768px`,
        desktop: `1200px`,
    },
};

export default breakpoints;
